<div id="information-reservation" uk-modal>
    <div class="uk-modal-dialog">
        <a class="uk-modal-close-default">
            <img src="../../../../assets/icons/Close.svg" height="32px" width="32px">
        </a>
        <div class="uk-modal-body">
            <title class="uk-modal-title color-grey">Réservation</title>
            <div class="uk-display-inline-block research-form-controls uk-width-1-1 uk-margin-remove">
                <h2 class="bold color-grey uk-text-uppercase">Réservation</h2>
                <div class="uk-form-stacked" *ngIf="page === 1">
                    <div class="uk-margin">
                        <h2 class="color-grey uk-text-uppercase">30/10/2000 14h à 16h</h2>
                    </div>
                    <div class="uk-grid-small">
                        <!-- <div class="uk-width-1-1 color-grey remove-grid-ml-pl"> -->
                            <div class="">
                                <img class="uk-position-absolute" style="left: 10px;" src="../../../assets/icons/User.svg" width="64px" height="64px" alt="user"/>
                            </div>
                            <div class="">
                                <span>Fabien Bouns</span>
                            </div>
                        <!-- </div>
                        <div class="uk-width-1-1 color-grey remove-grid-ml-pl"> -->
                            <div class="">
                                <img class="uk-position-absolute" style="left: 10px;" src="../../../assets/icons/Vehicle.svg" width="48px" height="48px" alt="adherent"/>
                            </div>
                            <div class="" style="font-size: 15px;">
                                <span>W-820-JS</span>
                            </div>
                        <!-- </div> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="uk-modal-footer uk-column">
            <p class="uk-text-left">
                <button (click)="sinistre()" class="button uk-text-danger bold" type="button">Déclarer un sinistre</button>
            </p>
            <p class="uk-text-right">
                <button (click)="facture()" class="button uk-margin-small-left" type="button">
                    <span class="bold">Telecharger la facture correspondante</span>
                    <span class="bold" *ngIf="loadingAccountCreation === true"><div style="width: 15px;" uk-spinner></div></span>
                </button>
            </p>
        </div>
    </div>
</div>